import { optionalText } from "~/shared/lib/filterHelpers";

export interface ILicenseManagementUrlParams {
  page?: string;
  count?: string;
  dealerId?: string;
  dealerName?: string;
  organizationId?: string;
  partnerName?: string;
  branchCode?: string;
  inn?: string;
  year?: string;
  actionType?: string;
  status?: string;
  decision?: string;
  createdFrom?: string;
  createdTo?: string;
  updatedFrom?: string;
  updatedTo?: string;
  sortField?: string;
  sortType?: string;
  openModal?: string;
  currentId?: string;
}

export interface ILicenseAdminFilter {
  dealerId?: string;
  dealerName?: string;
  organizationId?: string;
  partnerName?: string;
  branchCode?: string;
  inn?: string;
  year?: string;
  actionType?: string;
  status?: string;
  decision?: string;
  createdFrom?: string;
  createdTo?: string;
  updatedFrom?: string;
  updatedTo?: string;
}

export const parseLicenseAdminFilterFromUrl = (
  params: ILicenseManagementUrlParams,
): ILicenseAdminFilter => ({
  dealerId: optionalText(params.dealerId),
  dealerName: optionalText(params.dealerName),
  organizationId: optionalText(params.organizationId),
  partnerName: optionalText(params.partnerName),
  branchCode: optionalText(params.branchCode),
  inn: optionalText(params.inn),
  year: optionalText(params.year),
  actionType: optionalText(params.actionType),
  status: optionalText(params.status),
  decision: optionalText(params.decision),
  createdFrom: params.createdFrom || undefined,
  createdTo: params.createdTo || undefined,
  updatedFrom: params.updatedFrom || undefined,
  updatedTo: params.updatedTo || undefined,
});
